export enum Sex {
  Unknown = 0,
  Male = 1,
  Female = 2,
}
